module.exports = __webpack_public_path__ + "img/part3.e3130338.jpg";